import React, { useState } from 'react';
import { GoogleButton, StackIcon } from '../assets/svgs/svgs';

const GoogleOAuthModal = ({ onContinue, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleBackdropClick = (e) => {
    e.stopPropagation();
  };

  const handleGoogleConnect = async () => {
    setIsLoading(true);
    await onContinue();
    setIsLoading(false);
  }


  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      onClick={handleBackdropClick}
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-md" />      
      <div 
        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-visible"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
          <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center">
            <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center">
              <StackIcon/>
            </div>
          </div>
        </div>
        <div className="px-8 pt-12 pb-6 text-center">
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Welcome Back!
          </h2>
          <p className="text-base text-[#57534E] mb-5 leading-relaxed">
            Connect your Google account to access your dashboard securely.
          </p>
          <button
            onClick={handleGoogleConnect}
            disabled={isLoading}
            className="w-full bg-[#6B4423] text-white font-medium py-3 px-6 rounded-lg flex items-center justify-center gap-2 hover:bg-[#5a3a1e] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <GoogleButton/>
            {isLoading ? 'Connecting...' : 'Continue With Google'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoogleOAuthModal;